<template>
    <main>
        <section class="p-6 w-full">
            <form-member
                v-if="open"
                :roles="roles"
                :edit="member"
            ></form-member>
        </section>
    </main>
</template>

<script>
export default {
    components: {},
    mounted() {
        Eventing.listen("fetchRoles", () => this.getRoles());
        this.getRoles();
    },
    created() {},
    data() {
        return {
            member: {
                iban: {},
                ice: {},
                address: {},
                groups: [],
                membertypes: [],
                voting_weight: 1,
                initials: "+",
            },
            warning: false,
            roles: [],
            open: false,
        };
    },
    methods: {
        getRoles() {
            axios
                .get("/api/modules/roles")
                .then((response) => {
                    this.roles = response.data;
                    this.open = true;
                })
                .catch((error) => {});
        },
    },
};
</script>
